<template>
  <div>
    <div v-loading="loading">
      <div v-if="!loading">
        <div v-if="keijibanList.length > 0">
          <div v-for="(item, idx) in keijibanList" :key="item.keijibanId">
            <table width="100%" border=0 style="font-size:15px;line-height:1.5em;">
              <tr>
                <td>
                  <span class="notice">{{ item.keijibanDate }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  {{ item.keijibanJiho }}
                </td>
              </tr>
            </table>
            <br>
          </div>
        </div>
        <div v-else><br>データがありません<br><br></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Keijiban',
    props: {
      keijibanList: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>

<style scoped>
  .notice {
    background-color: #d4ecf4;
    font-size: 14px;
    white-space: nowrap; /* 改行しない */
  }
</style>